(() => {
  // app/scripts/multi-selectors.js
  document.addEventListener("DOMContentLoaded", () => {
    const disclosures = document.querySelectorAll("[data-disclosure-locale], [data-disclosure-currency]");
    disclosures.forEach((disclosure) => {
      const toggleButton = disclosure.querySelector("[data-disclosure-toggle]");
      const optionList = disclosure.querySelector("[data-disclosure-list]");
      const inputField = disclosure.querySelector("[data-disclosure-input]");
      const form = disclosure.closest("[data-disclosure-form]");
      if (!toggleButton || !optionList || !inputField || !form)
        return;
      toggleButton.addEventListener("click", (event) => {
        event.stopPropagation();
        const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
        toggleButton.setAttribute("aria-expanded", !isExpanded);
        optionList.classList.toggle("disclosure-list--visible", !isExpanded);
      });
      optionList.addEventListener("click", (event) => {
        const option = event.target.closest("[data-disclosure-option]");
        if (!option)
          return;
        event.preventDefault();
        inputField.value = option.getAttribute("data-value");
        form.submit();
      });
      document.addEventListener("click", (event) => {
        if (!disclosure.contains(event.target)) {
          optionList.classList.remove("disclosure-list--visible");
          toggleButton.setAttribute("aria-expanded", "false");
        }
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          optionList.classList.remove("disclosure-list--visible");
          toggleButton.setAttribute("aria-expanded", "false");
        }
      });
    });
  });
})();
